import { render, staticRenderFns } from "./AssetTask.vue?vue&type=template&id=47673a2c&scoped=true&"
import script from "./AssetTask.vue?vue&type=script&lang=js&"
export * from "./AssetTask.vue?vue&type=script&lang=js&"
import style0 from "./AssetTask.vue?vue&type=style&index=0&id=47673a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47673a2c",
  null
  
)

export default component.exports